import React, { useEffect, useState } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import {
  MaintenanceHeader,
  selectTabEnum
} from '../components/organisms/Maintenance/MaintenanceHeader';
import { MaintenanceOtherTitle } from '../components/organisms/Maintenance/MaintenanceOtherTitle';
import {
  SettingsType,
  MaintenanceSettingsTable
} from '../components/organisms/Maintenance/Table/MaintenanceSettingsTable';
import { GetSettingsApi } from '../apis/GetMaintenance.api';
import { chooseDataStateType } from '../components/molecules/MaintenanceModalDispLabels';
import { SettingsEditWindow } from '../components/organisms/Maintenance/EditWindow/SettingsEditWindow';

export type SettingsStateType = {
  type: 'settings';
  settings: SettingsType | null | undefined;
};

export const SettingsMaintenance: React.FC = () => {
  const [maintenanceDatas, setMaintenanceDatas] = useState<
    SettingsType[] | null | undefined
  >();
  const [chooseData, setChooseData] = useState<
    SettingsType | null | undefined
  >();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const stateUpdate = (data: chooseDataStateType) => {
    if (data.type === 'settings') {
      setChooseData(data.settings);
    }
  };
  const GetApi = async () => {
    const response = await GetSettingsApi();
    if (response.success) {
      setMaintenanceDatas(response.data);
    }
  };

  useEffect(() => {
    GetApi();
  }, []);

  return (
    <>
      <Flex direction='column' h='100vh'>
        <MaintenanceHeader selectTab={selectTabEnum.Settings} />
        <MaintenanceOtherTitle selectTab={selectTabEnum.Settings} />
        <Box
          position='relative'
          display='grid'
          gridTemplateRows='0.1fr 2fr 0.1fr'
          gridTemplateColumns='3fr 1fr'
          h='100%'
        >
          <MaintenanceSettingsTable
            SettingsDatas={maintenanceDatas}
            onOpen={onOpen}
            setChooseData={stateUpdate}
          />

          {isOpen && (
            <SettingsEditWindow
              isOpen={isOpen}
              onClose={onClose}
              EditData={chooseData}
              setMaintenanceDatas={setMaintenanceDatas}
            />
          )}
        </Box>
      </Flex>
    </>
  );
};
